import Swiper, {Pagination, Autoplay, Navigation} from 'swiper';
import {gsap} from 'gsap';
import {ScrollTrigger} from 'gsap/ScrollTrigger';
import {ScrollToPlugin} from 'gsap/ScrollToPlugin';
// import HorizontalScroll from './HorizontalScroll';
// import ResponsiveSwiper from './ResponsiveSwiper';
import AnchorLinks from './AnchorLinks';
import Accordion from './Accordion';
import Marquee from './Marquee';
import Vision from './Vision';
import Milestones from './Milestones';

gsap.registerPlugin(ScrollTrigger, ScrollToPlugin);

class GeneralBlocks {
    constructor(wWidth) {
        this.initHeroSlider();
        this.initSeatsSlider();
        this.initTeamSlider();
        this.initProductSlider();
        this.initBlogCarousel();
        this.initLatestNewsSlider();
        this.initPinnedLayout();
        this.initHeroParallax();
        this.initTestimonialsSlider();
        this.initTeamTestimonialsSlider();
        this.initProductHeroAnimation();
        /*

        this.gridSwiper = $('.grid-layout--swiper').map(
          (i, el) => new ResponsiveSwiper(el, wWidth)
        );
        this.latestPosts = $('.latest-posts').map(
          (i, el) => new ResponsiveSwiper(el, wWidth)
        );
         */
        this.anchorLinks = $('.anchor-links').map(
            (i, el) => new AnchorLinks(el, wWidth)
        );
        this.accordions = $('.accordion').map((i, el) => new Accordion(el));
        this.marquees = $('.marquee__inner').map((i, el) => new Marquee(el));
        this.visions = $('.vision').map((i, el) => new Vision(el));
        this.milestones = $('.milestones').map(
            (i, el) => new Milestones(el, wWidth)
        );
    }

    onResize(wWidth) {
        this.wWidth = wWidth;

        /*
        this.gridSwiper.each((i, el) => {
          if (el.onResize) el.onResize(wWidth);
        });
        this.latestPosts.each((i, el) => {
          if (el.onResize) el.onResize(wWidth);
        });

         */
        this.anchorLinks.each((i, el) => {
            if (el.onResize) el.onResize(this.wWidth);
        });

        this.marquees.each((i, item) => {
            if (item.onResize) item.onResize();
        });

        this.milestones.each((i, item) => {
            if (item.onResize) item.onResize(this.wWidth);
        });
    }

    initHeroSlider() {
        this.$hero = $('.hero');
        this.$heroSwiper = $('.hero .swiper-slide');

        if (this.$heroSwiper.length < 1) return;

        this.$hero.each((i, el) => {
            const $pagination = $(el).find('.swiper-pagination__bullet');
            const $fraction = $(el).find('.swiper-pagination__fraction');
            const $slides = $(el).find('.swiper-slide');
            const slideCount = $slides.length;
            $fraction.text(`1 / ${slideCount}`);

            // eslint-disable-next-line no-new
            const heroSwiper = new Swiper($(el)[0], {
                loop: true,
                modules: [Pagination, Autoplay],
                speed: 700,
                autoplay: {
                    delay: 4000,
                },
                pagination: {
                    el: $pagination.get(0),
                    clickable: true,
                },
                on: {
                    slideChange: () => {
                        $fraction.text(`${heroSwiper.realIndex + 1} / ${slideCount}`);
                    },
                },
            });
        });
    }

    initHeroParallax() {
        this.$heroSlider = $('.hero');

        if (!this.$heroSlider.length) return;

        // calculate bottom code only if window width is higher than 1023px
        if (window.innerWidth > 1023) {
            gsap.utils.toArray('.hero').forEach((hero, i) => {
                ScrollTrigger.create({
                    trigger: hero,
                    start: 'top top',
                    end: 'bottom top',
                    pin: true,
                    pinSpacing: false,
                    onUpdate: (self) => {
                        const progress = self.progress.toFixed(2);
                        const $content = $(hero).find('.hero__content-inner');
                        $content.css('transform', `translateY(-${progress * 200}%)`);
                    },
                });
            });
        }
    }

    initProductHeroAnimation() {
        if ($(window).width() < 1024) return;

        // test
        this.$lockedSection = document.querySelector('.product-hero');
        this.$lockedSectionAfter = document.querySelector('.product-hero-end');
        if (!this.$lockedSection) return;

        this.imageElement = this.$lockedSection.querySelector('.hero__media');
        this.textElement = this.$lockedSection.querySelector(
            '.product-hero__content'
        );

        gsap.set([this.textElement], {opacity: 0});

        ScrollTrigger.create({
            trigger: this.$lockedSection,
            start: 'top top',
            end: '+=1200',
            scrub: false,
            pin: true,
            markers: false,
            fastScrollEnd: false,
            onUpdate: (self) => {
                const {progress} = self;
                // const progressCustom = self.progress + 0.4;
                gsap.to(this.imageElement, {
                    xPercent: 30 * progress,
                    ease: 'power1.inOut',
                    overwrite: 'auto',
                });
            },
        });

        ScrollTrigger.create({
            trigger: this.$lockedSectionAfter,
            start: 'top top',
            end: '+=800',
            scrub: true,
            pin: true,
            markers: false,
            fastScrollEnd: true,
            onUpdate: (self) => {
                const {progress} = self;
                gsap.to(this.textElement, {
                    opacity: progress * 1,
                    ease: 'power1.inOut',
                    overwrite: 'auto',
                });
            },
        });
    }

    initSeatsSlider() {
        if (!$('.seats-slider__wrapper').length) return;

        let swiper = null;

        $('.seats-slider__switcher-item').on('click', function () {
            const _this = $(this),
                  _parent = _this.closest('.seats-slider__wrapper'),
                  _id = _this.data('id');

            _parent.attr('data-layout', _id)

            // change active item
            _this.parent().find('.seats-slider__switcher-item').removeClass('active')
            _this.addClass('active')

            // init/destroy swiper
            if ( _id === 'list' ) {
                const $prev = _parent.find('.swiper-button-prev');
                const $next = _parent.find('.swiper-button-next');

                // eslint-disable-next-line no-new
                swiper = new Swiper(_parent.find('.seats-slider__container')[0], {
                    loop: false,
                    modules: [Navigation, Autoplay],
                    speed: 700,
                    slidesPerView: 'auto',
                    navigation: {
                        nextEl: $next[0],
                        prevEl: $prev[0],
                    },
                });
            } else {
                swiper.destroy()
            }
        })
    }

    initLatestNewsSlider() {
        this.$latestNews = $('.latest-news');
        if (!this.$latestNews.length) return;

        this.$latestNews.each((i, el) => {
            // eslint-disable-next-line no-new
            new Swiper($(el)[0], {
                loop: false,
                modules: [Navigation, Autoplay],
                speed: 700,
                slidesPerView: 'auto',
            });
        });
    }

    initBlogCarousel() {
        this.$blogCarousel = $('.blog-carousel-swiper');
        if (!this.$blogCarousel.length) return;

        this.$blogCarousel.each((i, el) => {
            const $parent = $(el).parents('.blog-carousel');

            const $prev = $parent.find('.swiper-button-prev');
            const $next = $parent.find('.swiper-button-next');

            // eslint-disable-next-line no-new
            new Swiper($(el)[0], {
                loop: false,
                modules: [Navigation, Autoplay],
                speed: 700,
                slidesPerView: 'auto',
                navigation: {
                    nextEl: $next[0],
                    prevEl: $prev[0],
                },
            });
        });
    }

    initTeamSlider() {
        if (!$('.team-slider__wrapper').length) return;

        let swiper = null;

        $('.team-slider__switcher-item').on('click', function () {
            const _this = $(this),
                _parent = _this.closest('.team-slider__wrapper'),
                _id = _this.data('id');

            _parent.attr('data-layout', _id)

            // change active item
            _this.parent().find('.team-slider__switcher-item').removeClass('active')
            _this.addClass('active')

            // init/destroy swiper
            if ( _id === 'list' ) {
                const $prev = _parent.find('.swiper-button-prev');
                const $next = _parent.find('.swiper-button-next');

                // eslint-disable-next-line no-new
                swiper = new Swiper(_parent.find('.team-slider__container')[0], {
                    loop: false,
                    modules: [Navigation, Autoplay],
                    speed: 500,
                    slidesPerView: 'auto',
                    autoplay: false,
                    navigation: {
                        nextEl: $next[0],
                        prevEl: $prev[0],
                    },
                });
            } else {
                swiper.destroy()
            }
        })
    }

    initProductSlider() {
        this.$productSlider = $('.product-slider__wrapper');
        if (!this.$productSlider.length) return;

        this.$productSlider.each((i, el) => {
            const $prev = $(el).find('.swiper-button-prev');
            const $next = $(el).find('.swiper-button-next');

            // eslint-disable-next-line no-new
            new Swiper($(el)[0], {
                loop: false,
                modules: [Navigation, Autoplay],
                speed: 500,
                slidesPerView: 'auto',
                autoplay: false,
                navigation: {
                    nextEl: $prev[0],
                    prevEl: $next[0],
                },
            });
        });
    }

    initTestimonialsSlider() {
        this.$testimonialsSlider = $('.testimonials-quotes-swiper');
        if (!this.$testimonialsSlider.length) return;

        this.$testimonialsSlider.each((i, el) => {
            const $prev = $(el).find('.swiper-button-prev');
            const $next = $(el).find('.swiper-button-next');

            // eslint-disable-next-line no-new
            new Swiper($(el)[0], {
                loop: false,
                modules: [Navigation, Autoplay],
                speed: 500,
                slidesPerView: 1,
                autoplay: false,
                centeredSlides: true,
                navigation: {
                    nextEl: $next[0],
                    prevEl: $prev[0],
                },
            });
        });
    }

    initTeamTestimonialsSlider() {
        this.$teamTestimonialsSlider = $('.team-testimonials__wrapper');
        if (!this.$teamTestimonialsSlider.length) return;

        this.$teamTestimonialsSlider.each((i, el) => {
            const $prev = $(el)
                .parent('.team-testimonials__container')
                .find('.swiper-button-prev');

            const $next = $(el)
                .parent('.team-testimonials__container')
                .find('.swiper-button-next');

            // eslint-disable-next-line no-new
            new Swiper($(el)[0], {
                loop: false,
                modules: [Navigation, Autoplay],
                speed: 500,
                slidesPerView: 'auto',
                autoplay: false,
                navigation: {
                    nextEl: $next[0],
                    prevEl: $prev[0],
                },
            });
        });
    }

    initPinnedLayout() {
        gsap.defaults({overwrite: 'auto'});
        gsap.set('.left-content > *', {
            xPercent: -50,
            yPercent: -50,
        });

        // Set up our scroll trigger
        const ST = ScrollTrigger.create({
            trigger: '.content-container',
            start: 'top top',
            end: 'bottom bottom',
            onUpdate: getCurrentSection,
            pin: '.left-content',
        });

        // test
        const contentMarkers = gsap.utils.toArray('.contentMarker');

        // Set up our content behaviors
        contentMarkers.forEach((marker) => {
            marker.content = document.querySelector(
                `#${marker.dataset.markerContent}`
            );

            console.log(marker.content, 'marker content');

            if (marker.content.tagName === 'IMG') {
                gsap.set(marker.content, {transformOrigin: 'center'});

                marker.content.enter = function () {
                    gsap.fromTo(
                        marker.content,
                        {autoAlpha: 0, rotateY: -30},
                        {duration: 0.3, autoAlpha: 1, rotateY: 0}
                    );
                };
            } else if (marker.content.tagName === 'BLOCKQUOTE') {
                gsap.set(marker.content, {transformOrigin: 'left center'});

                marker.content.enter = function () {
                    gsap.fromTo(
                        marker.content,
                        {autoAlpha: 0, rotateY: 50},
                        {duration: 0.3, autoAlpha: 1, rotateY: 0}
                    );
                };
            }

            marker.content.leave = function () {
                gsap.to(marker.content, {duration: 0.1, autoAlpha: 0});
            };
        });

        let lastContent;

        // Handle the updated position
        function getCurrentSection() {
            let newContent;
            const currScroll = scrollY;

            // Find the current section
            contentMarkers.forEach((marker) => {
                if (currScroll > marker.offsetTop) {
                    newContent = marker.content;
                }
            });

            // If the current section is different than that last, animate in
            if (
                newContent &&
                (lastContent == null || !newContent.isSameNode(lastContent))
            ) {
                // Fade out last section
                if (lastContent) {
                    lastContent.leave();
                }

                // Animate in new section
                newContent.enter();

                lastContent = newContent;
            }
        }

        const media = window.matchMedia('screen and (max-width: 600px)');
        ScrollTrigger.addEventListener('refreshInit', checkSTState);
        // eslint-disable-next-line no-use-before-define
        checkSTState();

        function checkSTState() {
            if (media.matches) {
                ST.disable();
            } else {
                ST.enable();
            }
        }
    }
}

export default GeneralBlocks;
